module.exports = __webpack_public_path__ + "static/media/01-256.82ad5264.ico";